import { createSlice } from '@reduxjs/toolkit';
import { defaultShippingQuoteSlice, emptyInvoiceShippingQuote, emptyItemShippingQuote } from './shippingQuote.types';
import { fetchInvoiceShippingQuote, fetchLotShippingQuote } from './shippingQuote.actions';
import difference from 'lodash/difference';
import union from 'lodash/union';

const shipingQuoteSlice = createSlice({
    extraReducers: (builder) => {
        // lot
        builder.addCase(fetchLotShippingQuote.pending, (slice, { meta }) => {
            if (slice.loading.indexOf(meta.arg.itemId) < 0) {
                slice.loading = union(slice.loading, [meta.arg.itemId]);
            }
            slice.byId[meta.arg.itemId] = emptyItemShippingQuote;
            slice.error = undefined;
            slice.result = undefined;
            slice.type = 'lot';
        });

        builder.addCase(fetchLotShippingQuote.fulfilled, (slice, { meta, payload }) => {
            const loadingIndex = slice.loading.indexOf(meta.arg.itemId);
            if (loadingIndex >= 0) {
                slice.loading = difference(slice.loading, [meta.arg.itemId]);
            }
            slice.loaded[meta.arg.itemId] = Date.now();

            slice.byId[meta.arg.itemId] = {
                ...payload,
                country: meta.arg.countryCode,
                postalCode: meta.arg.postalCode,
            };

            slice.result = 'success';
        });

        builder.addCase(fetchLotShippingQuote.rejected, (slice, { meta, payload }) => {
            const loadingIndex = slice.loading.indexOf(meta.arg.itemId);
            if (loadingIndex >= 0) {
                slice.loading = difference(slice.loading, [meta.arg.itemId]);
            }
            slice.error = payload.toString();
            slice.result = 'failure';
        });

        // invoice
        builder.addCase(fetchInvoiceShippingQuote.pending, (slice, { meta }) => {
            if (slice.loading.indexOf(meta.arg.invoiceId) < 0) {
                slice.loading = union(slice.loading, [meta.arg.invoiceId]);
            }
            slice.byId[meta.arg.invoiceId] = emptyInvoiceShippingQuote;
            slice.error = undefined;
            slice.result = undefined;
            slice.type = 'invoice';
        });

        builder.addCase(fetchInvoiceShippingQuote.fulfilled, (slice, { meta, payload }) => {
            const loadingIndex = slice.loading.indexOf(meta.arg.invoiceId);
            if (loadingIndex >= 0) {
                slice.loading = difference(slice.loading, [meta.arg.invoiceId]);
            }
            slice.loaded[meta.arg.invoiceId] = Date.now();

            slice.byId[meta.arg.invoiceId] = {
                ...payload,
            };

            slice.result = 'success';
        });

        builder.addCase(fetchInvoiceShippingQuote.rejected, (slice, { meta, payload }) => {
            const loadingIndex = slice.loading.indexOf(meta.arg.invoiceId);
            if (loadingIndex >= 0) {
                slice.loading = difference(slice.loading, [meta.arg.invoiceId]);
            }
            slice.error = payload.toString();
            slice.result = 'failure';
        });
    },
    initialState: defaultShippingQuoteSlice,
    name: 'shippingQuote',
    reducers: {},
});

export const { reducer: shippingQuoteReducer } = shipingQuoteSlice;
